export default __webpack_public_path__ + "media/images/front/about/matching-5511eccbcd6315213d3bf4f368ccff47.png";